module.exports = __webpack_public_path__ + "img/pixing_xc12.7a499d52.jpg";